import { tempo } from '@tempo/core';
/**
 * Padding between section's content and the border of the screen
 */ const containerGutters = {
    base: 'spacing.l',
    sm: '64px',
    lg: '112px',
    xl: '192px',
    '2xl': '288px'
};
/**
 * Spacing between 2 sections
 */ const interSectionSpacing = {
    base: '80px',
    md: '160px'
};
/**
 * Spacing to use between the main content and the rest description part
 */ const sectionContentSpacing = {
    base: 'spacing.3xl',
    md: '56px',
    lg: '64px'
};
/**
 * Spacing between 2 elements in the description / textual part of a section
 */ const sectionDescriptionSpacing = {
    base: 'spacing.l',
    md: 'spacing.2xl'
};
/**
 * Simple containerbox for landings
 */ export const LandingPage = tempo('div', {
    baseStyle: {
        w: '100%'
    }
});
export const useLandingPageScales = ()=>{
    return {
        containerGutters,
        sectionContentSpacing,
        sectionDescriptionSpacing,
        interSectionSpacing
    };
};

//# sourceMappingURL=LandingPage.js.map